import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { commonErrorMessage } from 'utils/error-message';
import ja from 'utils/ja';

import { ChangeDBFormType } from './Header';

interface ClusterDBProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<ChangeDBFormType, any, ChangeDBFormType>;
  onConfirm: () => void;
}

const ClusterDBDialog: React.FC<ClusterDBProps> = ({
  open,
  setOpen,
  control,
  onConfirm,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          maxWidth: '840px',
          width: '100%',
          height: 'auto',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '45px',
          padding: 0,
        }}
      >
        {ja.setting.db}
        <Divider />
      </DialogTitle>
      <Box sx={{ '& *': { fontSize: '40px !important' }, mt: '10px' }}>
        <Controller
          name='dbId'
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <FormControl variant='standard' fullWidth sx={{ mt: '20px' }}>
              <Typography component='p' mb='15px'>
                {ja.setting.db_id.label}
                <Typography component='span' color={theme.palette.error.main}>
                  *
                </Typography>
              </Typography>
              <TextField
                id='dbId'
                placeholder={ja.setting.db_id.placeholder}
                {...field}
              />
              {fieldState.error && (
                <Typography
                  sx={{
                    color: theme.palette.error.main,
                    fontSize: theme.typography.fontSize,
                    my: '5px',
                  }}
                >
                  {commonErrorMessage.MSE00003(ja.setting.db_id.label)}
                </Typography>
              )}
            </FormControl>
          )}
        />
        <Controller
          name='dbKey'
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <FormControl variant='standard' fullWidth sx={{ mt: '20px' }}>
              <Typography component='p' mb='15px'>
                {ja.setting.db_key.label}
                <Typography component='span' color={theme.palette.error.main}>
                  *
                </Typography>
              </Typography>
              <TextField
                id='dbKey'
                placeholder={ja.setting.db_key.placeholder}
                {...field}
              />
              {fieldState.error && (
                <Typography
                  sx={{
                    color: theme.palette.error.main,
                    fontSize: theme.typography.fontSize,
                    my: '5px',
                  }}
                >
                  {commonErrorMessage.MSE00003(ja.setting.db_key.label)}
                </Typography>
              )}
            </FormControl>
          )}
        />
      </Box>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          sx={{ fontSize: '40px', padding: 0 }}
        >
          {ja.setting.cancel}
        </Button>
        <Button onClick={onConfirm} sx={{ fontSize: '40px', padding: 0 }}>
          {ja.setting.OK}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClusterDBDialog;
